// src/pages/AuthCallbackPage.js
import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Loader from "../components/common/custom-component/Loader";

export default function AuthCallbackPage() {
    const navigate = useNavigate();
    const { isLoading, isAuthenticated } = useAuth();

    useEffect(() => {
        if (isLoading) return;

        const targetPath = isAuthenticated ? '/userCompanies' : '/login';

        if (window.self !== window.top) {
            // In iframe - navigate parent
            window.parent.location.href = targetPath;
        } else {
            // Not in iframe - use React Router
            navigate(targetPath, { replace: true });
        }
    }, [isLoading, isAuthenticated, navigate]);

    return (

        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
            gap: 2
        }}>
            <Loader
                variant="circular"
                message="Please wait while we complete your login..."
                size="small"
            />
        </Box>

    );
}